export interface BattleSyncSnapshot {
  id?: string;
  status: string;
  round?: number;
  submitted: boolean;
  log?: unknown[];
}

/**
 * HTTP-ответ на первый ход может прийти после WebSocket-кадра, который уже
 * перевёл бой на следующий раунд. Не позволяем запоздавшему снимку вернуть
 * интерфейс назад к старому «Ход сделан».
 */
export function preferBattleSnapshot<T extends BattleSyncSnapshot>(current: T | null, next: T): T {
  if (!current || current.id !== next.id) return next;
  if (current.status === "finished" && next.status !== "finished") return current;
  if (next.status === "finished") return next;

  const currentRound = current.round ?? 0;
  const nextRound = next.round ?? 0;
  if (nextRound < currentRound) return current;
  if (nextRound > currentRound) return next;

  const currentLogLength = current.log?.length ?? 0;
  const nextLogLength = next.log?.length ?? 0;
  if (nextLogLength < currentLogLength) return current;
  if (nextLogLength > currentLogLength) return next;
  if (current.submitted && !next.submitted) return current;
  return next;
}
